import './css/app.css';

import header from './js/components/header';
import logoSlider from './js/components/logoSlider';
import reviewsCarousel from './js/components/reviewsCarousel';
import announcementBar from './js/components/announcementBar';
import mobileSubmenu from './js/components/mobileSubmenu';
import localizeMenu from './js/components/localizeMenu';
import helpMenu from './js/components/helpMenu';
import search from './js/components/search';
import mainSearch from './js/components/mainSearch';
import tabSwitcher from './js/components/tabSwitcher';
import heroSwiper from './js/components/heroSwiper';
import reassuranceSlider from './js/components/reassuranceSlider';
import roomSlider from './js/components/roomSlider';
import inspirationFilter from './js/components/inspirationFilter';
import hotspotBubble from './js/components/hotspotBubble';
import accordion from './js/components/accordion';
import productCard from './js/components/productCard';
import productCarousel from './js/components/productCarousel';
import collectionFilter from './js/components/collectionFilter';
import faq from './js/components/faq';
import collectionDepartments from './js/components/departmentsFilter';
import priceRange from './js/components/priceRange';
import productImageCarousel from './js/components/productImageCarousel';
import colorVariant from './js/components/colorVariant';
import productSelectVariants from './js/components/productSelectVariants';
import productSimpleVariant from './js/components/productSimpleVariant';
import collectionTagFilter from './js/components/collectionTagFilter';
import closetConfigurator from './js/components/closetConfigurator';
import cartDrawer from '~/js/components/cart-drawer';
import cartNote from '~/js/components/cart-note';
import getColorSwatches from '~/js/components/getColorSwatches';
import reassuranceSliderV2 from './js/components/reassuranceSliderV2';
import styleCollection from './js/components/style-collection';
import imageReveal from './js/components/imageReveal';
import variantDimensions from './js/components/variantDimensions';
import spacePlanningForm from './js/components/hr-form';
import formspreeRequest from './js/components/formspree-new-request';
import newVariant from './js/components/newVariant';
import getMetaobjects from './js/components/getMetaobjects';

const componentsMap = {
  header,
  mobileSubmenu,
  localizeMenu,
  helpMenu,
  search,
  mainSearch,
  tabSwitcher,
  roomSlider,
  logoSlider,
  reviewsCarousel,
  announcementBar,
  heroSwiper,
  reassuranceSlider,
  inspirationFilter,
  hotspotBubble,
  accordion,
  productCard,
  productCarousel,
  collectionFilter,
  faq,
  collectionDepartments,
  priceRange,
  productImageCarousel,
  colorVariant,
  productSelectVariants,
  productSimpleVariant,
  collectionTagFilter,
  closetConfigurator,
  cartDrawer,
  cartNote,
  getColorSwatches,
  reassuranceSliderV2,
  styleCollection,
  imageReveal,
  variantDimensions,
  spacePlanningForm,
  formspreeRequest,
  newVariant,
  getMetaobjects,
};

const mountComponents = () => {
  const components = document.querySelectorAll('[data-component]');

  components.forEach((el) => {
    const component = el.dataset.component;

    if (componentsMap[component]) {
      componentsMap[component](el);
    }
  });
};

const mountAccordions = (e) => {
  let component = null;
  // mobile slider
  const accordionComponent = e.detail.node;
  if (accordionComponent) {
    component = accordionComponent.dataset.component;
    if (componentsMap[component]) {
      componentsMap[component](accordionComponent);
    }
  }
};

const mountProductCards = (e) => {
  let component = null;
  // mobile slider
  const productCardComponent = e.detail.node;
  if (productCardComponent) {
    component = productCardComponent.dataset.component;
    if (componentsMap[component]) {
      componentsMap[component](productCardComponent);
    }
  }
};

const mountStyleCollection = (e) => {
  let component = null;
  // mobile slider
  const styleCollectionButton = e.detail.node;
  if (styleCollectionButton) {
    component = styleCollectionButton.dataset.component;
    if (componentsMap[component]) {
      componentsMap[component](styleCollectionButton);
    }
  }
};

const mountPriceRange = (e) => {
  let component = null;
  // mobile slider
  const priceRangeComponent = e.detail.node;
  if (priceRangeComponent) {
    component = priceRangeComponent.dataset.component;
    if (componentsMap[component]) {
      componentsMap[component](priceRangeComponent);
    }
  }
};

const anchorToForm = (e) => {
  const params = new URLSearchParams(window.location.search);
  const formId = params.get('form-id');
  if (formId) {
    let maxTries = 10;
    let tries = 0;
    while (tries < maxTries) {
      const el = document.querySelector(
        `[data-forms-id="forms-root-${formId}"]`
      );
      if (el) {
        setTimeout(() => {
          const yOffset = -100; // offset in pixels
          const y =
            el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 1000);
        tries = maxTries + 1;
      } else {
        // wait 500ms and try again
        setTimeout(() => {}, 1000);
      }
      tries++;
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  (function () {
    const STYLE_ID = 'pt-font-style';

    function applyFontToPaymentTerms(el) {
      const root = el.shadowRoot;
      if (!root) return;

      // Avoid duplicating the style tag
      if (root.getElementById(STYLE_ID)) return;

      const style = document.createElement('style');
      style.id = STYLE_ID;

      style.textContent = `
        :host, #shopify-installments, #shopify-installments * {
          font-family: var(--payment-terms-font-family, inherit) !important;
        }
      `;

      root.appendChild(style);
    }

    function scan() {
      document
        .querySelectorAll('shopify-payment-terms')
        .forEach(applyFontToPaymentTerms);
    }

    // Run now
    scan();

    // Re-run when DOM changes (theme sections / variant updates)
    const observer = new MutationObserver(() => scan());
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    // Optional: if your theme triggers custom events on variant change,
    // you can also hook them here (safe to leave as-is).
  })();
});
document.addEventListener('DOMContentLoaded', mountComponents);
document.addEventListener('DOMContentLoaded', anchorToForm);
document.addEventListener('shopify:section:load', mountComponents);
document.addEventListener('shopify:section:load:accordion', mountAccordions);
document.addEventListener(
  'shopify:section:load:product-cards',
  mountProductCards
);
document.addEventListener(
  'shopify:section:load:style-collection',
  mountStyleCollection
);
document.addEventListener('shopify:section:load:price-range', mountPriceRange);
